import React, { useState } from "react";
import FileIcon from "../../../Assests/Images/FileIcon.svg";
import trashIcon from "../../../Assests/Images/trash.svg";
import "./index.scss";
import DocPreviewModal from "./Modal";
import { section2Completed } from "../../../utils/constants";

const DocumentOption = ({
  fileName,
  deleteUploadedDoc = null,
  fileSrc,
  employeeTransactionData,
}) => {
  const [docPreview, setDocPreView] = useState(false);

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = fileSrc;
    link.download = fileName || "download";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <div
        className="d-flex align-items-center justify-content-between doc-option-continer"
        role="button"
        onClick={() => setDocPreView(true)}
      >
        <div className="d-flex gap-2 align-items-center">
          <img src={FileIcon} alt="captureIcon" width={40} height={40} />
          <span className="doc-title">
            <abbr title={fileName}>{fileName}</abbr>
          </span>
        </div>
        {deleteUploadedDoc &&
          (employeeTransactionData?.userStatus !== section2Completed) && (
            <img
              src={trashIcon}
              className="delete-file"
              alt="trashIcon"
              role="button"
              width={20}
              height={20}
              onClick={(event) => {
                event.stopPropagation();
                deleteUploadedDoc();
              }}
            />
          )}
      </div>
      <DocPreviewModal
        isOpen={docPreview}
        close={() => setDocPreView(false)}
        confirm={handleDownload}
        fileSrc={fileSrc}
      />
    </>
  );
};

export default DocumentOption;
